import { useEffect, useState } from "react";
import { _Inbox, _single, _UBLInvoice } from "../../../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../../../core/services/dataBean/useDataBean";
import { toast } from "react-toastify";
import { _SupplierPaymentOrder, _SupplierPaymentOrderItem } from "../../../../../../core/services/dataBean/EntityCatalogVdos";
import { BasicButton } from "../../../../../theme/Component/BasicButton";
import { Modal } from "../../../../../theme/Component/Modal";
import { CreateUBLInvoiceItems } from "../../../../../contract/etapa-contrato/contrac/ublinvoice/CreateUBLInvoice/CreateUBLInvoiveItem";


interface ProcedureFunctions {
    _exportMap: Function;
    _procedure: any;
    _pocessData?: any;
    _pushInfo?: Function;
    _pushProps?: Function;
}

interface Props {
    configProcedure: ProcedureFunctions;
}

export const SOP005 = ({ configProcedure }: Props) => {

    const { instance } = useDataBean(_UBLInvoice);
    const [props, setProps] = useState<any>({});
    const [obs, setObs] = useState<string>("")
    const [errorList, setErrorList] = useState<any>([])
    const [modalErrorList, setModalErrorList] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modalObs, setModalObs] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });

    useEffect(() => {
        if (configProcedure?._pocessData?.Props) {
            setProps(configProcedure?._pocessData?.Props)
        }
    }, [configProcedure?._pocessData])

    const onExportMap = () => {
        if (configProcedure?._pushInfo) {
            configProcedure?._pushInfo(obs)
        }

        if (configProcedure?._exportMap) {
            configProcedure?._exportMap({ response: obs })
        }
        toast.success('Factura agregada')
    }

    const validateInvoice = () => {
        instance.requestUBLInvoiceToAccounting(props.IDUBLInvoice, props.UBLIssueDate, _single.getAccountID(), "").then(
            (resp) => {
                if (resp.ErrorList.length == 0) {
                    toast.success("Relación correcta");
                    setModalObs({ ...modalObs, "view": true, "name": "Agregar observación y enviar" });
                } else {
                    setErrorList(resp.ErrorList)
                    setModalErrorList({ ...modalErrorList, "view": true, "name": "Se encontraron las siguientes incidencias con la factura" });
                    toast.warning("Factura con problemas");
                }
            }
        ).catch(
            err => {
                toast.error(err, { autoClose: false });
            }
        )
    }

    return (
        <div className="row">
            {props.IDUBLInvoice ?
                <div className="col-md-12">
                    <CreateUBLInvoiceItems
                        _data={props}
                        issueDate={props.UBLIssueDate}
                        idUBLInvoice={props.IDUBLInvoice}
                    />
                </div>
                :
                <p>Cargando....</p>
            }
            <div className="col-md-12 mt-4">
                <BasicButton eventClick={() => { validateInvoice() }} icon="ri-send-plane-line" >Validar y Enviar Relacion de Factura</BasicButton>
            </div>

            <div className="col-md-12">
                <Modal modal={modalObs} updateModal={modalObs} eventModal={() => {
                    if (obs.length > 15) {
                        onExportMap()
                    } else {
                        toast.error("La observacion debe tener minimo 15 caracteres")
                    }
                }}>
                    <div className="col-md-12 mt-2">
                        <label>Observaciones</label>
                        <textarea name="Description" className="form-control" rows={5} value={obs} onChange={(e) => { setObs(e.target.value) }} />
                    </div>
                </Modal>
            </div>

            <div className="col-md-12">
                <Modal modal={modalErrorList} updateModal={setModalErrorList}  >
                    <div className="col-md-12">
                        <hr />
                        <ul className="list-group">
                            {
                                errorList.map((item: any, index: number) => {
                                    return (
                                        <li className="list-group-item">
                                            {index + 1} - {item}
                                        </li>
                                    )
                                })
                            }
                        </ul>
                    </div>
                </Modal>
            </div>
        </div>

    )
}